export const ACCOUNT_TYPE_BUYER = 'buyer';
export const ACCOUNT_TYPE_SELLER = 'seller';
export const PLATFORM_EDI_EXTERNAL_SFTP = 'edi-sftp-external';
export const PLATFORM_EDI_SFTP = 'edi-sftp';

export const TEST_ORDER_FLAGGED_MESSAGE =
  'This is a test order, you must confirm the sync before you can proceed';

export const SHOPIFY_APP_STORE_URL =
  'https://apps.shopify.com/modern-dropship-by-carro?show_store_picker=1';

export const NAV_IS_MOBILE_MAX_WIDTH = 768;

export const MARKETPLACE_FILTERS_WIDTH = 230;
